
export function addError (errors, field, message) {
  if (!errors)
    errors={}

  errors[field] = message;
  return errors;
  }
